//const { indexOf } = require("core-js/core/array");

$(".tabsaccor ul li a").attr({"aria-selected": false});
$(".tabsaccor ul li:first-child a").addClass("active").attr({"tabindex": 0, "aria-selected": true});
$(".item-tab").first().addClass("active").attr({"tabindex": 0, "aria-selected": true});
tabControl();

/*
We also apply the switch when a viewport change is detected on the fly
(e.g. when you resize the browser window or flip your device from 
portrait mode to landscape). We set a timer with a small delay to run 
it only once when the resizing ends. It's not perfect, but it's better
than have it running constantly during the action of resizing.
*/

var resizeTimer;
$(window).on("resize", function (e) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    tabControl();
  }, 250);
});

/*
The function below is responsible for switching the tabs when clicked.
It switches both the tabs and the accordion buttons even if 
only the one or the other can be visible on a screen. We prefer
that in order to have a consistent selection in case the viewport
changes (e.g. when you esize the browser window or flip your 
device from portrait mode to landscape).
*/
function tabControl() {
  var tabs = $(".tabbed-content").find(".tabsaccor");
  if (tabs.is(":visible")) {
    tabs.find("a").on("click", function (event) {
      event.preventDefault();
      var target = $(this).attr("href"),
        tabs = $(this).parents(".tabsaccor"),
        buttons = tabs.find("a"),
        item = tabs.parents(".tabbed-content").find(".item-tab");
      buttons.removeClass("active").attr('aria-selected', false);
      item.removeClass("active").attr({"tabindex": -1});
      $(this).addClass("active").attr('aria-selected', true);
      $(target).addClass("active").attr({"tabindex": 0});
    });

    tabs.find("a").on("keydown", function (e){
      var curntTab = $(this).attr("aria-controls");

      let activeTab = document.createElement('span');
      let textnode = document.createTextNode("Active Tab")
      activeTab.classList.add('screen-reader-text');
      activeTab.append(textnode);


      if (e.keyCode === 13) {
        tabs.find("a").removeClass('active').attr({"aria-selected": false}).find("span").remove();
        $(this).addClass('active').attr({"tabindex": 0, "aria-selected": true});        
        $(this).append(activeTab);

        $('.item-tab').attr({"tabindex": -1}).removeClass('active');  
        $('#' + curntTab).attr({"tabindex": 0}).addClass('active').focus();
        //tabs.find("a").attr({"hidden": false, "tabindex": 0});
      }

      //Arrow down
      if(e.keyCode === 40){
        curntTabNo = curntTab.substring(8);
        nextTabNo = parseInt(curntTabNo) + 1;
        
        if($('.tab-'+nextTabNo).length > 0){
          $(this).attr({"tabindex": -1});
          $('.tab-'+nextTabNo).attr({"tabindex": 0}).focus();
        }        
      }
      //Arrow up  
      if(e.keyCode === 38){
        curntTabNo = curntTab.substring(8);
        prevTabNo = parseInt(curntTabNo) - 1;
        
        if($('.tab-'+prevTabNo).length > 0){
          $(this).attr({"tabindex": -1});
          $('.tab-'+prevTabNo).attr({"tabindex": 0}).focus();
        }        
      }  
    })

  } else {
    var titleListAll = document.querySelectorAll(".tabbed-content .tabsaccor li a");
    var titleList = Array.prototype.slice.call(titleListAll);
    titleList.forEach(title => {
      let getId = title.getAttribute("href").substring(1);
      let curntSection = document.getElementById(getId);
      //   let plusMinus = document.createElement("span");
      let cloneHeading = title.cloneNode(true);
      cloneHeading.classList.add('tab-mobile-heading');      
     
      // //console.log(curntSection);
      // if(curntSection.contains(document.querySelector('.tab-mobile-heading'))){
      //   console.log('already there');
      // } else {
      //   curntSection.prepend(cloneHeading);
      //   console.log('not there yet, please add');
      // }

      //console.log(curntSection.firstElementChild);

      if(curntSection.firstElementChild.classList.contains('tab-mobile-heading')){
        console.log('aaaa');
      } else {
        curntSection.prepend(cloneHeading);
        console.log('bbb');
      }
      
    });

    $(".item-tab").on("click", function (e) {
      e.preventDefault();
      var container = $(this).parents(".tabbed-content"),
        currId = $(this).attr("id"),
        items = container.find(".item-tab");

      container.find(" a").removeClass("active");
      items.removeClass("active");
      $(this).addClass("active");
      container.find(' a[href$="#' + currId + '"]').addClass("active");
    });
  }
}
